// TODO: Remove, stand alone snapshots dead
export default () => {
  return '';
};
